import React from 'react';
import './Pages/PagesCss/PrivacyPolicy.css';

const Disclaimer = () => {
  return (
    <div className="privacy-policy">
      {/* Header Section */}
      <section className="policy-header">
        <div className="container">
          <div className="header-content">
            <h1>Disclaimer</h1>
            <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            <p className="header-description">
              Important information regarding the use of our financial calculator tools and services. 
              Please read this disclaimer carefully before using our website.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="policy-content">
        <div className="container">
          <div className="policy-grid">
            {/* Table of Contents */}
            <aside className="table-of-contents">
              <h3>Table of Contents</h3>
              <nav>
                <ul>
                  <li><a href="#no-financial-advice">No Financial Advice</a></li>
                  <li><a href="#educational-purpose">Educational Purpose Only</a></li>
                  <li><a href="#accuracy-limitations">Accuracy Limitations</a></li>
                  <li><a href="#investment-risks">Investment Risks</a></li>
                  <li><a href="#tax-disclaimer">Tax Disclaimer</a></li>
                  <li><a href="#professional-advice">Professional Advice</a></li>
                  <li><a href="#past-performance">Past Performance</a></li>
                  <li><a href="#user-responsibility">User Responsibility</a></li>
                  <li><a href="#third-party-content">Third-Party Content</a></li>
                  <li><a href="#limitation-liability">Limitation of Liability</a></li>
                  <li><a href="#contact">Contact Information</a></li>
                </ul>
              </nav>
            </aside>

            {/* Disclaimer Sections */}
            <div className="policy-sections">
              <section id="no-financial-advice" className="policy-section">
                <h2>1. No Financial Advice</h2>
                <p>
  This Disclaimer applies to all websites and subdomains operated by D-Tech Studios for noobtobull, including <a href="https://noobtobull.com" target="_blank" rel="noopener noreferrer">https://noobtobull.com</a> and <a href="https://blog.noobtobull.com" target="_blank" rel="noopener noreferrer">https://blog.noobtobull.com</a>.
</p>
                <div className="section-content">
                  <div className="security-features">
                    <h3>Important Notice</h3>
                    <p>
                      <strong>noobtobull does not provide financial advice.</strong> Our calculators and tools 
                      are designed for informational and educational purposes only. Nothing on this website 
                      constitutes, and should not be regarded as, financial advice in any form.
                    </p>
                  </div>

                  <h3>1.1 Informational Purpose</h3>
                  <p>
                    The content and tools provided on noobtobull are for informational purposes only. 
                    We are not licensed financial advisors, brokers, or tax professionals. The 
                    information provided should not be interpreted as:
                  </p>
                  <ul>
                    <li>Investment recommendations or advice</li>
                    <li>Financial planning guidance</li>
                    <li>Tax advice or preparation services</li>
                    <li>Endorsement of any financial product or service</li>
                    <li>Recommendation to buy, sell, or hold any security</li>
                  </ul>

                  <h3>1.2 No Advisory Relationship</h3>
                  <p>
                    Using our calculators does not create a financial advisor-client relationship. 
                    We are not acting as your financial advisor, broker, or tax preparer.
                  </p>
                </div>
              </section>

              <section id="educational-purpose" className="policy-section">
                <h2>2. Educational Purpose Only</h2>
                <div className="section-content">
                  <p>
                    Our financial calculators are intended to be educational tools that help users 
                    understand various financial concepts and perform calculations. They are designed to:
                  </p>
                  <ul>
                    <li>Demonstrate financial principles and mathematical relationships</li>
                    <li>Provide estimates for planning and educational purposes</li>
                    <li>Help users learn about different financial scenarios</li>
                    <li>Serve as a starting point for further research and professional consultation</li>
                  </ul>

                  <div className="security-features">
                    <h3>Educational Tool Only</h3>
                    <p>
                      <strong>Our calculators are learning aids, not decision-making tools.</strong> 
                      They should be used as part of a broader educational process, not as the sole 
                      basis for financial decisions.
                    </p>
                  </div>
                </div>
              </section>

              <section id="accuracy-limitations" className="policy-section">
                <h2>3. Accuracy and Limitations</h2>
                <div className="section-content">
                  <h3>3.1 Calculation Estimates</h3>
                  <p>
                    All calculations provided by our tools are estimates based on the information 
                    you input and the mathematical formulas we employ. These calculations:
                  </p>
                  <ul>
                    <li>Are based on standard mathematical formulas and assumptions</li>
                    <li>May not reflect real-world market conditions or transaction costs</li>
                    <li>Do not account for all possible variables and scenarios</li>
                    <li>Should be verified with professional sources</li>
                  </ul>

                  <h3>3.2 No Guarantees</h3>
                  <p>
                    While we strive to provide accurate calculations, we do not guarantee the 
                    accuracy, completeness, reliability, or timeliness of any information on our website. 
                    Financial markets are dynamic and unpredictable, and actual results may vary 
                    significantly from our estimates.
                  </p>

                  <h3>3.3 Formula Assumptions</h3>
                  <p>
                    Our calculators use standard financial formulas that make certain assumptions. 
                    These assumptions may not hold true in all market conditions or for your specific 
                    financial situation.
                  </p>
                </div>
              </section>

              <section id="investment-risks" className="policy-section">
                <h2>4. Investment Risks Disclosure</h2>
                <div className="section-content">
                  <div className="security-features">
                    <h3>Risk Warning</h3>
                    <p>
                      <strong>All investments involve risk, including the possible loss of principal.</strong> 
                      Past performance does not guarantee future results. The value of investments may 
                      fluctuate, and investors may not get back the amount invested.
                    </p>
                  </div>

                  <h3>4.1 Market Risks</h3>
                  <p>Investing involves various types of risks including but not limited to:</p>
                  <ul>
                    <li><strong>Market Risk:</strong> The possibility of losing money due to overall market declines</li>
                    <li><strong>Interest Rate Risk:</strong> Changes in interest rates affecting investment values</li>
                    <li><strong>Inflation Risk:</strong> The risk that inflation will erode investment returns</li>
                    <li><strong>Liquidity Risk:</strong> The inability to sell investments when desired</li>
                    <li><strong>Concentration Risk:</strong> Overexposure to a single investment or sector</li>
                  </ul>

                  <h3>4.2 No Risk Assessment</h3>
                  <p>
                    Our calculators do not assess your personal risk tolerance, financial situation, 
                    or investment objectives. They provide mathematical calculations only, without 
                    consideration of your individual circumstances.
                  </p>
                </div>
              </section>

              <section id="tax-disclaimer" className="policy-section">
                <h2>5. Tax Disclaimer</h2>
                <div className="section-content">
                  <h3>5.1 Not Tax Advice</h3>
                  <p>
                    Our tax-related calculators are for educational and estimation purposes only. 
                    We are not licensed tax professionals, and our tools should not be used for 
                    actual tax preparation or filing.
                  </p>

                  <h3>5.2 Tax Law Changes</h3>
                  <p>
                    Tax laws and regulations change frequently and vary by jurisdiction. Our 
                    calculators may not reflect the most current tax laws or your specific tax 
                    situation. Always consult with a qualified tax professional for tax advice.
                  </p>

                  <div className="security-features">
                    <h3>Tax Professional Required</h3>
                    <p>
                      <strong>Consult a qualified tax professional</strong> for advice about your 
                      specific tax situation. Our calculators provide estimates only and should not 
                      be used for tax filing purposes.
                    </p>
                  </div>
                </div>
              </section>

              <section id="professional-advice" className="policy-section">
                <h2>6. Professional Advice Recommendation</h2>
                <div className="section-content">
                  <p>
                    We strongly recommend that you seek advice from qualified professionals before 
                    making any financial decisions. This includes consulting with:
                  </p>

                  <div className="rights-grid">
                    <div className="right-item">
                      <h4>Financial Advisors</h4>
                      <p>For investment advice and financial planning</p>
                    </div>
                    <div className="right-item">
                      <h4>Tax Professionals</h4>
                      <p>For tax planning and preparation</p>
                    </div>
                    <div className="right-item">
                      <h4>Accountants</h4>
                      <p>For accounting and financial reporting</p>
                    </div>
                    <div className="right-item">
                      <h4>Legal Counsel</h4>
                      <p>For legal matters related to investments</p>
                    </div>
                  </div>

                  <h3>6.1 Individual Circumstances</h3>
                  <p>
                    Financial professionals can consider your complete financial picture, including 
                    your goals, risk tolerance, time horizon, and personal circumstances—factors 
                    that our calculators cannot account for.
                  </p>
                </div>
              </section>

              <section id="past-performance" className="policy-section">
                <h2>7. Past Performance Disclaimer</h2>
                <div className="section-content">
                  <div className="security-features">
                    <h3>Important Investment Principle</h3>
                    <p>
                      <strong>Past performance is not indicative of future results.</strong> 
                      Historical data and back-tested performance should not be construed as 
                      an indication of future performance.
                    </p>
                  </div>

                  <h3>7.1 Historical Calculations</h3>
                  <p>
                    Any calculations based on historical data are for educational purposes only 
                    and do not guarantee future performance. Market conditions change, and 
                    strategies that worked in the past may not work in the future.
                  </p>

                  <h3>7.2 Forward-Looking Statements</h3>
                  <p>
                    Our calculators may produce forward-looking estimates based on assumptions 
                    about future performance. These are mathematical projections only and should 
                    not be interpreted as predictions or guarantees.
                  </p>
                </div>
              </section>

              <section id="user-responsibility" className="policy-section">
                <h2>8. User Responsibility</h2>
                <div className="section-content">
                  <h3>8.1 Independent Verification</h3>
                  <p>
                    You are solely responsible for verifying the accuracy of any calculations 
                    and for making your own independent assessment of the information provided. 
                    You should:
                  </p>
                  <ul>
                    <li>Verify calculations with other sources</li>
                    <li>Consider multiple perspectives and scenarios</li>
                    <li>Research thoroughly before making decisions</li>
                    <li>Understand the limitations of any financial tool</li>
                  </ul>

                  <h3>8.2 Financial Decisions</h3>
                  <p>
                    You assume all responsibility and risk for any financial decisions you make, 
                    whether or not you used our calculators as part of your decision-making process. 
                    We are not responsible for any financial losses or consequences resulting from 
                    your decisions.
                  </p>
                </div>
              </section>

              <section id="third-party-content" className="policy-section">
                <h2>9. Third-Party Content and Links</h2>
                <div className="section-content">
                  <h3>9.1 External References</h3>
                  <p>
                    Our website may contain references to third-party content, websites, or services. 
                    These are provided for informational purposes only, and we:
                  </p>
                  <ul>
                    <li>Do not endorse or guarantee the accuracy of third-party content</li>
                    <li>Are not responsible for the content of linked sites</li>
                    <li>Do not control third-party websites or their policies</li>
                  </ul>

                  <h3>9.2 Due Diligence</h3>
                  <p>
                    You should conduct your own due diligence and research when using any third-party 
                    resources referenced on our website.
                  </p>

                  <p>
      We may use third-party services such as Google Analytics or advertising partners to improve our services. 
      These services may collect anonymized data about your interactions with our websites.
    </p>
                </div>
              </section>

              <section id="limitation-liability" className="policy-section">
                <h2>10. Limitation of Liability</h2>
                <div className="section-content">
                  <div className="security-features">
                    <h3>No Liability for Financial Decisions</h3>
                    <p>
                      <strong>To the fullest extent permitted by law, noobtobull shall not be liable</strong> 
                      for any damages, losses, or expenses of any kind arising from your use of our 
                      calculators or reliance on the information provided.
                    </p>
                  </div>

                  <h3>10.1 Types of Excluded Damages</h3>
                  <p>This includes, but is not limited to:</p>
                  <ul>
                    <li>Direct, indirect, incidental, or consequential damages</li>
                    <li>Loss of profits, investments, or savings</li>
                    <li>Financial losses of any kind</li>
                    <li>Opportunity costs</li>
                    <li>Emotional distress</li>
                  </ul>

                  <h3>10.2 Maximum Liability</h3>
                  <p>
                    In no event shall our total liability to you for all damages exceed zero dollars ($0.00 USD), as this tool is provided free of charge.
                  </p>
                </div>
              </section>

              <section id="contact" className="policy-section">
                <h2>11. Contact Information</h2>
                <div className="section-content">
                  <p>
                    If you have any questions about this disclaimer or need clarification about 
                    the appropriate use of our calculators, please contact us:
                  </p>
                  <div className="contact-info">
                    <div className="contact-item">
                      <strong>Email:</strong> support@noobtobull.com
                    </div>
                    <div className="contact-item">
                      <strong>Address:</strong>  2568 Madison Ave, League City, TX 77573
                    </div>
                    <div className="contact-item">
                      <strong>Purpose:</strong> For questions about calculator usage and educational purposes only
                    </div>
                  </div>

                  <div className="security-features">
                    <h3>Final Reminder</h3>
                    <p>
                      <strong>Remember:</strong> Our calculators are educational tools, not financial advice. 
                      Always consult qualified professionals for financial decisions affecting your personal 
                      circumstances.
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Actions */}
      <section className="policy-actions">
        <div className="container">
          <div className="actions-content">
            <h3>Understand Our Tools</h3>
            <p>Make sure you understand the educational nature of our calculators before using them for your financial planning.</p>
            <div className="action-buttons">
              <a href="/Contact" className="btn btn-primary">Ask Questions</a>
              <a href="/" className="btn btn-secondary">Browse Calculators</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Disclaimer;